import React from 'react';
import './aragovde.css';
import Reveal from './Reveal';

const features = [
  {
    id: 'hizli',
    icon: (
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="aragovde-icon-svg">
        <circle cx="24" cy="24" r="22" stroke="currentColor" strokeWidth="2.5" />
        <path d="M24 12v12l7 4" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M10 24h4M34 24h4M24 10v-2M24 38v2" stroke="currentColor" strokeWidth="2" strokeLinecap="round" opacity="0.4" />
      </svg>
    ),
    title: 'Hızlı İşlem Oluşturma',
    desc: 'Telefon aracılığı ile sipariş verebilir, bunlara ilişkin alım ve satım işlemlerini en hızlı şekilde yaptırabilirsiniz.',
  },
  {
    id: 'guvenlik',
    icon: (
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="aragovde-icon-svg">
        <path d="M24 4L8 10v12c0 10 7 18.5 16 22 9-3.5 16-12 16-22V10L24 4z" stroke="currentColor" strokeWidth="2.5" strokeLinejoin="round" />
        <path d="M16 24l5.5 5.5L32 19" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    ),
    title: 'Güvenlik Seçenekleri',
    desc: 'Varlıklarınızı ofisinize veya istediğiniz bir bankaya zırhlı servis araçlarımız ile getirtebilirsiniz.',
  },
  {
    id: 'kazanc',
    icon: (
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="aragovde-icon-svg">
        <path d="M8 36l10-12 8 6 14-18" stroke="currentColor" strokeWidth="2.8" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="38" cy="12" r="3.5" stroke="currentColor" strokeWidth="2.5" />
        <path d="M8 40h32" stroke="currentColor" strokeWidth="2" strokeLinecap="round" opacity="0.4" />
      </svg>
    ),
    title: 'Yüksek Kazanç',
    desc: 'Özel kur opsiyonlarını seçerek, birikimlerinizde daha kazançlı yatırım olanağı sağlayabilirsiniz.',
  },
  {
    id: 'odeme',
    icon: (
      <svg viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" className="aragovde-icon-svg">
        <rect x="6" y="13" width="36" height="24" rx="4" stroke="currentColor" strokeWidth="2.5" />
        <path d="M6 21h36" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" />
        <path d="M12 30h8M28 30h8" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" opacity="0.5" />
      </svg>
    ),
    title: 'Kolay ve Hızlı Ödeme',
    desc: 'Havale, EFT, nakit yolları ile ofise, bankaya veya iş yerlerinize servis ile gerçekleştirebilme kolaylığını sunmaktadır.',
  },
];

const Aragovde: React.FC = () => {
  return (
    <section className="aragovde-container">
      <div className="aragovde-content">

        <Reveal variant="fade-up" duration={600}>
          <div className="aragovde-header">
            <p className="aragovde-eyebrow">Neden ATS Döviz?</p>
            <h2 className="aragovde-title">ATS Döviz her zaman müşterilerinin yanındadır</h2>
            <span className="aragovde-title-underline" />
            <p className="aragovde-subtitle">Bizimle çalışmanın avantajlarını kaçırmayın!</p>
          </div>
        </Reveal>

        <div className="aragovde-grid">
          {features.map((f, i) => (
            <Reveal key={f.id} variant="fade-up" duration={600} delay={i * 100}>
              <div className="aragovde-card">
                <div className="aragovde-icon-wrap">
                  {f.icon}
                </div>
                <h3 className="aragovde-card-title">{f.title}</h3>
                <p className="aragovde-card-desc">{f.desc}</p>
                <span className="aragovde-card-line" />
              </div>
            </Reveal>
          ))}
        </div>

      </div>
    </section>
  );
};

export default Aragovde;
